import React from "react";

import Croppie from "croppie";
import "croppie/croppie.css";

class ReactCroppie extends React.Component {
  componentDidMount() {
    this.croppie = new Croppie(this.img, this.props.options);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.src !== this.props.src) {
      this.croppie.bind({ url: this.props.src });
    }
  }

  componentWillUnmount() {
    if (this.img) {
      this.croppie.destroy();
      delete this.img;
      delete this.cropper;
    }
  }

  get = () => this.croppie.get();
  bind = options => this.croppie.bind(options);
  result = options => this.croppie.result(options);
  rotate = degrees => this.croppie.rotate(degrees);
  setZoom = value => this.croppie.setZoom(value);

  render = () => {
    const {src, alt, style, className} = this.props;

    return (
      <div
        style={style}
        className={className}
      >
        <img
          ref={img => this.img = img}
          src={src}
          alt={alt || "croppie"}
        />
      </div>
    );
  }

}

export default ReactCroppie;

